<template>
    <div>
        <!-- 防水阶段详情弹窗 -->
        <el-dialog :title="'防水阶段详情'" :visible="visibleStage" fullscreen @close="closeDialog"
            :close-on-click-modal="false" append-to-body class="fixed-header-footer-dialog">
            <!-- 报单基本信息 -->
            <div class="declaration-info" v-if="infoDetail && infoDetail.id">
                <div class="declaration-info-row">
                    <div class="declaration-info-item">
                        <span class="info-label">报单编号:</span>
                        <span class="info-value">{{ infoDetail.number || '-' }}</span>
                    </div>
                    <div class="declaration-info-item">
                        <span class="info-label">报单商家:</span>
                        <span class="info-value">{{ infoDetail.shopName || '-' }}</span>
                    </div>
                    <div class="declaration-info-item">
                        <span class="info-label">商家电话:</span>
                        <span class="info-value">{{ infoDetail.shopMobile || '-' }}</span>
                    </div>
                    <div class="declaration-info-item">
                        <span class="info-label">施工地址:</span>
                        <span class="info-value">{{ infoDetail.customAddress || '-' }}</span>
                    </div>
                    <div class="declaration-info-item">
                        <span class="info-label">业主姓名:</span>
                        <span class="info-value">{{ infoDetail.customName || '-' }}</span>
                    </div>
                    <div class="declaration-info-item">
                        <span class="info-label">业主电话:</span>
                        <span class="info-value">{{ infoDetail.customMobile || '-' }}</span>
                    </div>
                    <div class="declaration-info-item">
                        <span class="info-label">联系人:</span>
                        <span class="info-value">{{ infoDetail.contactName || '-' }}</span>
                    </div>
                    <div class="declaration-info-item">
                        <span class="info-label">联系电话:</span>
                        <span class="info-value">{{ infoDetail.contactMobile || '-' }}</span>
                    </div>
                    <div class="declaration-info-item">
                        <span class="info-label">户型:</span>
                        <span class="info-value">{{ infoDetail.houseType || '-' }}</span>
                    </div>
                    <div class="declaration-info-item">
                        <span class="info-label">创建时间:</span>
                        <span class="info-value">{{ infoDetail.createTime ? formatTimestamp(infoDetail.createTime) : '-' }}</span>
                    </div>
                </div>
            </div>
            <div class="stage-layout">
                <!-- 左侧导航 -->
                <div class="stage-sidebar">
                    <div class="sidebar-title">阶段列表</div>
                    <div class="sidebar-card-list">
                        <!-- 合并后的阶段卡片 -->
                        <div v-for="(item, index) in mergedStages" :key="'stage-' + index" class="sidebar-card"
                            :class="{ 'sidebar-card--active': activeMenu === 'stage-' + index }"
                            @click="handleMenuSelect('stage-' + index)">
                            <div class="sidebar-card__icon">
                                <el-icon class="el-icon-document"></el-icon>
                            </div>
                            <div class="sidebar-card__body">
                                <div class="sidebar-card__name">{{ item.name }}</div>
                                <div class="sidebar-card__tags">
                                    <el-tag size="mini" v-if="item.orderItem"
                                        :type="getStatusType(item.orderItem.status)" effect="light">
                                        {{ getStatusLabel(item.orderItem.status) }}
                                    </el-tag>
                                    <el-tag size="mini" v-if="item.costItem" type="info" effect="plain">
                                        费用
                                    </el-tag>
                                </div>
                            </div>
                            <i class="el-icon-arrow-right sidebar-card__arrow"></i>
                        </div>
                    </div>
                    <!-- 侧边栏无数据提示 -->
                    <div v-if="!loadingCost && mergedStages.length === 0" class="sidebar-empty">
                        <i class="el-icon-folder-opened" style="font-size: 28px; color: #c0c4cc;"></i>
                        <p>暂无阶段数据</p>
                    </div>
                </div>
                <!-- 右侧内容区 -->
                <div class="stage-content">
                    <!-- 合并阶段内容 -->
                    <div v-if="activeCategory === 'stage' && selectedMergedItem" class="content-scroll">
                        <!-- 计费版本切换（独立于费用详情卡片，始终可见） -->
                        <div class="cost-version-bar"
                            v-if="selectedCostItem && canSwitchCostVersion(selectedCostItem.status)">
                            <div class="version-switcher">
                                <span class="version-switcher__label"><i class="el-icon-price-tag"></i>计费版本</span>
                                <el-radio-group :value="normalizeCostVersion(selectedCostItem.costVersion)" size="mini"
                                    class="version-radio"
                                    @input="(v) => handleSwitchCostVersion(selectedCostItem.id, v, normalizeCostVersion(selectedCostItem.costVersion))">
                                    <el-radio label="V2">新工艺</el-radio>
                                    <!-- <el-radio label="V1">老工艺</el-radio> -->
                                </el-radio-group>
                            </div>
                        </div>
                        <!-- 费用部分 -->
                        <el-card shadow="hover" class="card"
                            v-if="selectedCostItem && selectedCostItem.costDetails && selectedCostItem.costDetails.length > 0">
                            <div slot="header" class="card-header">
                                <div class="card-title-wrap">
                                    <span class="card-title"><i class="el-icon-money"></i> {{ selectedCostItem.goodsName
                                        ||
                                        ' ' }} 费用详情</span>
                                </div>
                                <el-tag :type="getStatusType(selectedCostItem.status)">
                                    {{ getStatusLabel(selectedCostItem.status) }}
                                </el-tag>
                            </div>
                            <!-- 工费明细 -->
                            <div class="section-title"
                                v-if="selectedCostItem.costDetails && selectedCostItem.costDetails.length > 0">
                                <i class="el-icon-coin"></i> 工费明细
                            </div>
                            <el-table v-if="selectedCostItem.costDetails && selectedCostItem.costDetails.length > 0"
                                :data="selectedCostItem.costDetails" style="width: 100%" border fit size="small">
                                <el-table-column prop="name" label="费用项目" min-width="180"></el-table-column>
                                <el-table-column prop="num" label="数量" min-width="80">
                                    <template slot-scope="scope">{{ scope.row.num || 0 }}</template>
                                </el-table-column>
                                <el-table-column prop="price" label="单价(元)" min-width="100">
                                    <template slot-scope="scope">{{ scope.row.price || 0 }}</template>
                                </el-table-column>
                                <el-table-column prop="totalPrice" label="总价(元)" min-width="100">
                                    <template slot-scope="scope">{{ scope.row.totalPrice || 0 }}</template>
                                </el-table-column>
                                <el-table-column label="操作" min-width="120"
                                    v-if="!readonly && selectedCostItem.status === 'TO_BE_THE_FINAL'">
                                    <template slot-scope="scope">
                                        <el-button type="danger" size="small"
                                            @click.stop="deleteReduceItem(scope.row.id)"
                                            v-if="scope.row.flag === 1 && permission.JOINS_SALES_CLOUD_WF_COST_REDUCE_DEL">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="cost-summary" v-if="!readonly && selectedCostItem.status === 'TO_BE_THE_FINAL'">
                                <el-button type="primary" size="small"
                                    v-if="permission.JOINS_SALES_CLOUD_WF_COST_REDUCE"
                                    @click.stop="openReduceDialog(selectedCostItem.id)">扣费项审减</el-button>
                            </div>
                            <div class="cost-summary">
                                <p><strong>工费合计:</strong> <span class="text-primary">{{ selectedCostItem.newTotal || 0
                                }}</span></p>
                            </div>
                            <!-- 材料费用 -->
                            <div class="section-title"
                                v-if="selectedCostItem.materialDetails && selectedCostItem.materialDetails.length > 0">
                                <i class="el-icon-goods"></i> 材料费用
                            </div>
                            <el-table
                                v-if="selectedCostItem.materialDetails && selectedCostItem.materialDetails.length > 0"
                                :data="selectedCostItem.materialDetails" style="width: 100%" border fit size="small">
                                <el-table-column prop="name" label="费用项目" min-width="180"></el-table-column>
                                <el-table-column prop="num" label="数量" min-width="80">
                                    <template slot-scope="scope">{{ scope.row.num || 0 }}</template>
                                </el-table-column>
                                <el-table-column prop="price" label="单价(元)" min-width="100">
                                    <template slot-scope="scope">{{ scope.row.price || 0 }}</template>
                                </el-table-column>
                                <el-table-column prop="totalPrice" label="总价(元)" min-width="100">
                                    <template slot-scope="scope">{{ scope.row.totalPrice || 0 }}</template>
                                </el-table-column>
                            </el-table>
                            <div class="cost-summary" v-if="selectedCostItem.n">
                                <p><strong>材料费用:</strong> <span class="text-primary">{{ selectedCostItem.n || 0
                                }}</span></p>
                            </div>
                            <!-- 商家费用 -->
                            <div class="section-title"
                                v-if="selectedCostItem.merchantFees && selectedCostItem.merchantFees.length > 0">
                                <i class="el-icon-s-shop"></i> 商家费用
                            </div>
                            <el-table v-if="selectedCostItem.merchantFees && selectedCostItem.merchantFees.length > 0"
                                :data="selectedCostItem.merchantFees" style="width: 100%" border fit size="small">
                                <el-table-column prop="name" label="费用项目" min-width="180"></el-table-column>
                                <el-table-column prop="num" label="数量" min-width="80">
                                    <template slot-scope="scope">{{ scope.row.num || 0 }}</template>
                                </el-table-column>
                                <el-table-column prop="price" label="单价(元)" min-width="100">
                                    <template slot-scope="scope">{{ scope.row.price || 0 }}</template>
                                </el-table-column>
                                <el-table-column prop="totalPrice" label="总价(元)" min-width="100">
                                    <template slot-scope="scope">{{ scope.row.totalPrice || 0 }}</template>
                                </el-table-column>
                            </el-table>
                            <div class="cost-summary">
                                <p><strong>商家总费用:</strong> <span class="text-primary">{{ selectedCostItem.y || 0
                                }}</span></p>
                            </div>
                            <!-- 工程师信息 -->
                            <div class="info-section">
                                <p><strong>服务工程师:</strong> {{ selectedCostItem.EngineerName || '无' }}</p>
                                <p><strong>服务工程师手机号:</strong> {{ selectedCostItem.EngineerMobile || '无' }}</p>
                                <p v-if="selectedCostItem.laborCostFormula"><strong>实际人工费:</strong> {{
                                    selectedCostItem.laborCostFormula || '无' }}
                                </p>
                                <p><strong>此单收入及材料账户余额:</strong> {{ selectedCostItem.laborCostFormula1 || '无' }}</p>
                                <p v-if="selectedCostItem.basePitBonusFormula"><strong>其他支出:</strong> {{
                                    selectedCostItem.basePitBonusFormula || '无'
                                }}</p>
                            </div>
                            <!-- 材料兜底审核提示（红色警告） -->
                            <div class="material-shortage-warning"
                                v-if="currentShortageInfo && currentShortageInfo.materialShortageFlag === 'YES' && currentShortageInfo.warningText">
                                <i class="el-icon-warning"></i>
                                <span>{{ currentShortageInfo.warningText }}</span>
                            </div>
                            <div class="material-shortage-warning"
                                v-if="currentShortageInfo && currentShortageInfo.attendanceWarningText">
                                <i class="el-icon-warning"></i>
                                <span>{{ currentShortageInfo.attendanceWarningText }}</span>
                            </div>
                            <!-- 费用阶段审核按钮 -->
                            <div class="stage-action-buttons"
                                v-if="!readonly && selectedCostItem.status === 'TO_BE_THE_FINAL' && permission.JOINS_SALES_CLOUD_WF_COST_PASSORREFUSE">
                                <el-button type="primary" size="small" :loading="actionLoading"
                                    @click.stop="passStage(selectedCostItem.id)">通过</el-button>
                                <el-button type="danger" size="small" :loading="actionLoading"
                                    @click.stop="refuseStage(selectedCostItem.id)">拒绝</el-button>
                            </div>
                            <!-- 费用反审核按钮 -->
                            <!-- <div class="stage-action-buttons"
                                v-if="selectedCostItem.status === 'TO_BE_EVALUATED' || selectedCostItem.status === 'COMPLETE'">
                                <el-button type="warning" size="small" icon="el-icon-refresh"
                                    @click.stop="handleReverseReviewStage(selectedCostItem.id)">反审核</el-button>
                            </div> -->
                        </el-card>
                        <!-- 考勤信息卡片 -->
                        <el-card shadow="hover" class="card attendance-card" v-if="punchRecords && punchRecords.length > 0">
                            <div slot="header" class="card-header">
                                <span class="card-title"><i class="el-icon-time"></i> 考勤信息</span>
                            </div>
                            <div class="attendance-info">
                                <el-table :data="punchRecords" style="width: 100%" border size="small">
                                    <el-table-column label="打卡类型" width="100" align="center">
                                        <template slot-scope="scope">
                                            <el-tag :type="scope.row.punchType === 'ENTRANCE' ? 'success' : 'danger'" size="small">
                                                {{ scope.row.punchType === 'ENTRANCE' ? '进场' : '退场' }}
                                            </el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="punchTime" label="打卡时间" width="180" align="center"></el-table-column>
                                    <el-table-column label="打卡照片" align="center">
                                        <template slot-scope="scope">
                                            <viewer :images="formmaterImage(scope.row.photo)" v-if="scope.row.photo">
                                                <img v-for="src in formmaterImage(scope.row.photo)" :src="src" :key="src" class="punch-photo" />
                                            </viewer>
                                            <span v-else>-</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="address" label="打卡地址" align="center">
                                        <template slot-scope="scope">
                                            <span>{{ scope.row.address || '-' }}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-card>
                         <el-card shadow="hover" class="card attendance-card" v-if=" selectedCostItem && !selectedCostItem.costDetails">
                            <div class="material-shortage-warning"
                                v-if="currentShortageInfo && currentShortageInfo.materialShortageFlag === 'YES' && currentShortageInfo.warningText">
                                <i class="el-icon-warning"></i>
                                <span>{{ currentShortageInfo.attendanceWarningText }}</span>
                            </div>
                         </el-card>
                        <!-- 工单部分 -->
                        <el-card shadow="hover" class="card"
                            v-if="selectedOrderItem && selectedOrderItem.list && selectedOrderItem.list.length > 0">
                            <div slot="header" class="card-header">
                                <span class="card-title"><i class="el-icon-document-checked"></i> {{
                                    selectedOrderItem.goodsName || '工单详情'
                                    }}</span>
                                <!-- <el-tag :type="getStatusType(selectedOrderItem.status)">
                                    {{ getStatusLabel(selectedOrderItem.status) }}
                                </el-tag> -->
                            </div>
                            <div class="card-content">
                                <!-- 时间信息（报单时间/进场打卡时间/提交工单时间/审单时间），放在动态表单最上方 -->
                                <el-row class="stage-time-info"
                                    v-if="selectedOrderItem && (infoDetail.createTime || selectedOrderItem.attendanceTime || selectedOrderItem.submitTime || selectedOrderItem.auditTime)">
                                    <el-col :span="6">
                                        <span class="info-label">报单时间:</span>
                                        <span class="info-value">{{ infoDetail.createTime ?
                                            formatTimestamp(infoDetail.createTime) : '-'
                                            }}</span>
                                    </el-col>
                                    <el-col :span="6">
                                        <span class="info-label">进场打卡时间:</span>
                                        <span class="info-value">{{ selectedOrderItem.attendanceTime ?
                                            formatTimestamp(selectedOrderItem.attendanceTime) : '-' }}</span>
                                    </el-col>
                                    <el-col :span="6">
                                        <span class="info-label">提交工单时间:</span>
                                        <span class="info-value">{{ selectedOrderItem.submitTime ?
                                            formatTimestamp(selectedOrderItem.submitTime)
                                            : '-' }}</span>
                                    </el-col>
                                    <el-col :span="6">
                                        <span class="info-label">审单时间:</span>
                                        <span class="info-value">{{ selectedOrderItem.auditTime ?
                                            formatTimestamp(selectedOrderItem.auditTime) :
                                            '-' }}</span>
                                    </el-col>
                                </el-row>
                                <!-- 面积详情（放在右侧内容区阶段内容下方） -->
                                <el-card shadow="hover" v-if="areaDisplayList && areaDisplayList.length > 0"
                                    style="margin-top: 16px;">
                                    <div slot="header" class="card-header">
                                        <span class="card-title"><i class="el-icon-document"></i> 面积详情</span>
                                        <el-tag type="info" size="small">{{ areaDisplayList.length }}个区域</el-tag>
                                    </div>
                                    <div class="card-content">
                                        <div v-for="area in areaDisplayList" :key="area.key" class="area-block">
                                            <!-- ========== Branch A: 老UI（forceOldAreaUI 或 isOldAreaData+isShow）========== -->
                                            <template v-if="forceOldAreaUI || (isOldAreaData && isShow)">
                                                <div class="old-area-line">
                                                    <span class="old-area-name">{{ area.name }}</span>
                                                    <!-- 计算式（按 areaName 去重后用逗号拼接） -->
                                                    <span class="old-area-expr-wrap">
                                                        <span class="old-area-tag">计算式</span>
                                                        <span class="old-area-expr">{{ area.planeExpressions || '-' }}</span>
                                                    </span>
                                                    <span class="old-area-badge">{{ area.totalArea || area.area || '0.00' }} ㎡</span>
                                                </div>
                                            </template>
                                            <!-- ========== Branch B: 旧版UI（isNew!=1）========== -->
                                            <template v-else-if="isNew != 1">
                                                <div class="area-block-header">
                                                    <span class="area-block-name">{{ area.name }}</span>
                                                    <span class="area-block-total">面积：{{ area.area || area.totalArea || '0.00' }} ㎡</span>
                                                </div>
                                                <!-- 刚性顶部提示：rigid.area + 平面面积（对齐移动端 area-item-area-stack） -->
                                                <div v-if="area.rigid && area.rigid.planeArea" class="old-summary-row">
                                                    <span class="area-inline-tag tag-rigid">刚性</span>
                                                    <span class="old-summary-text">{{ area.rigid.area || '0.00' }} ㎡</span>
                                                    <span class="old-summary-plane">平面面积：{{ area.rigid.planeArea }} ㎡</span>
                                                </div>
                                                <!-- 部件明细表（周长/高度/平面面积/面积） -->
                                                <el-table :data="buildOldAreaRows(area)" border size="small"
                                                    style="width:100%; margin-top: 8px;">
                                                    <el-table-column label="类型" align="center" width="90">
                                                        <template slot-scope="scope">
                                                            <span class="area-inline-tag"
                                                                :class="scope.row.kind === 'rigid' ? 'tag-rigid' : 'tag-flexible'">
                                                                {{ scope.row.kind === 'rigid' ? '刚性' : '柔性' }}
                                                            </span>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="周长(m)" align="center">
                                                        <template slot-scope="scope">
                                                            <span>{{ scope.row.perimeter || '-' }}</span>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="高度(m)" align="center">
                                                        <template slot-scope="scope">
                                                            <span>{{ scope.row.height || '-' }}</span>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="平面面积(㎡)" align="center">
                                                        <template slot-scope="scope">
                                                            <span>{{ scope.row.planeArea || '-' }}</span>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="面积(㎡)" align="center" width="100">
                                                        <template slot-scope="scope">
                                                            <span :style="{ color: scope.row.kind === 'rigid' ? '#1989fa' : '#fa6400', fontWeight: 'bold' }">
                                                                {{ scope.row.area || '0' }}
                                                            </span>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                            </template>
                                            <!-- ========== Branch C: 新数据格式（isNew=1，默认） ========== -->
                                            <template v-else>
                                                <div class="area-block-header">
                                                    <span class="area-block-name">{{ area.name }}</span>
                                                    <span class="area-block-total">总面积：{{ area.totalArea || '0.00' }} ㎡</span>
                                                </div>
                                                <!-- 墙面分组 -->
                                                <div v-if="hasWallParts(area.parts)" class="parts-group group-wall">
                                                    <div class="parts-group-title-row">
                                                        <span class="parts-group-title">墙面</span>
                                                        <span class="parts-group-tip">周长 × 高度 = 面积</span>
                                                    </div>
                                                    <!-- 列标题（移动端 parts-cols-header） -->
                                                    <div class="parts-cols-header">
                                                        <span class="parts-col-tag">类型</span>
                                                        <span class="parts-col-input">周长(m)</span>
                                                        <span class="parts-col-x">×</span>
                                                        <span class="parts-col-input">高度(m)</span>
                                                        <span class="parts-col-result">面积(㎡)</span>
                                                    </div>
                                                    <el-table :data="wallParts(area.parts)" border size="small"
                                                        style="width:100%">
                                                        <el-table-column label="类型" align="center" width="100">
                                                            <template slot-scope="scope">
                                                                <span class="area-inline-tag"
                                                                    :class="scope.row.type === 'rigid' ? 'tag-rigid' : 'tag-flexible'">
                                                                    {{ scope.row.type === 'rigid' ? '刚性墙面' : '柔性墙面' }}
                                                                </span>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column label="周长(m)" align="center">
                                                            <template slot-scope="scope">
                                                                <span>{{ scope.row.perimeter || '-' }}</span>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column label="高度(m)" align="center">
                                                            <template slot-scope="scope">
                                                                <span>{{ scope.row.height || '-' }}</span>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column label="面积(㎡)" align="center">
                                                            <template slot-scope="scope">
                                                                <span :style="{ color: scope.row.type === 'rigid' ? '#1989fa' : '#fa6400', fontWeight: 'bold' }">
                                                                    {{ scope.row.area || '0' }}
                                                                </span>
                                                                <span v-if="scope.row.type === 'rigid'" class="area-tag-tip">计入总面积</span>
                                                                <span v-else class="area-tag-tip area-tag-tip--gray">不计总面积</span>
                                                            </template>
                                                        </el-table-column>
                                                    </el-table>
                                                </div>
                                                <!-- 平面分组 -->
                                                <div v-if="hasPlaneParts(area.parts)" class="parts-group group-plane">
                                                    <div class="parts-group-title-row">
                                                        <span class="parts-group-title">平面</span>
                                                        <span class="parts-group-tip">输入计算式自动算出面积</span>
                                                    </div>
                                                    <!-- 列标题 -->
                                                    <div class="parts-cols-header">
                                                        <span class="parts-col-tag">类型</span>
                                                        <span class="parts-col-expression">计算式</span>
                                                        <span class="parts-col-result">面积(㎡)</span>
                                                    </div>
                                                    <el-table :data="planeParts(area.parts)" border size="small"
                                                        style="width:100%">
                                                        <el-table-column label="类型" align="center" width="100">
                                                            <template slot-scope="scope">
                                                                <span class="area-inline-tag tag-plane">平面</span>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column label="计算式" align="center">
                                                            <template slot-scope="scope">
                                                                <span class="plane-expression-text" v-if="scope.row.expression">{{ scope.row.expression }}</span>
                                                                <span class="plane-expression-placeholder" v-else>-</span>
                                                            </template>
                                                        </el-table-column>
                                                        <el-table-column label="面积(㎡)" align="center" width="120">
                                                            <template slot-scope="scope">
                                                                <span style="color:#67c23a; font-weight:bold;">
                                                                    {{ scope.row.area || '0' }}
                                                                </span>
                                                            </template>
                                                        </el-table-column>
                                                    </el-table>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                    <div style="text-align:right;margin-top:10px;font-weight:bold;">
                                        总面积：{{ areaConfigDisplayTotal }} ㎡
                                    </div>
                                </el-card>
                                <el-row v-if="selectedOrderItem.list && selectedOrderItem.list.length > 0">
                                    <el-col v-for="column in processEvaluateItemList(selectedOrderItem.list)"
                                        :key="column.id" style="display: flex;align-items: center;text-align: center;"
                                        :span="getSpan(processEvaluateItemList(selectedOrderItem.list).length)">
                                        <strong>{{ column.fieldName }}:</strong>
                                        <span
                                            v-if="['input', 'checkbox', 'radio', 'integerInput', 'decimalInput'].includes(column.inputType)">{{
                                                column.fieldValue }}</span>
                                        <span v-else-if="column.inputType === 'star'"
                                            style="display: flex;align-items: center;text-align: center;">
                                            <el-rate v-model="column.fieldValue" disabled></el-rate>
                                            <span>{{ column.fieldValue == '1' ? '差' : column.fieldValue == '2' ? '一般'
                                                :
                                                column.fieldValue == '3' ? '好' : column.fieldValue == '4' ? '很好' :
                                                    column.fieldValue
                                                        == '5' ? '非常好' : '' }}</span>
                                        </span>
                                        <span v-else><time>{{ column.fieldValue }}</time></span>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24" v-if="totalPrice">
                                        <p style="font-weight: bold;color: #ff4949;">工程师费用合计: {{ totalPrice }}</p>
                                    </el-col>
                                </el-row>
                                <!-- 图片信息 -->
                                <div class="section-title"
                                    v-if="getStageImageFields(selectedOrderItem.list).length > 0">
                                    <i class="el-icon-picture-outline"></i> 图片信息
                                </div>
                                <div class="form-row" v-for="column in getStageImageFields(selectedOrderItem.list)"
                                    :key="column.id">
                                    <p class="gap-line-border" v-if="column.inputType === 'img'|| column.inputType === 'photoOnly'">
                                        <span class="nameStyle">{{ column.fieldName }}:</span>
                                        <span class="gap-line"></span>
                                        <span v-if="column.fieldValue">
                                            <viewer :images="formmaterImage(column.fieldValue)">
                                                <img v-for="src in formmaterImage(column.fieldValue)" :src="src"
                                                    :key="src" class="card-image" />
                                            </viewer>
                                        </span>
                                        <span v-else>暂无图片</span>
                                    </p>
                                </div>
                            </div>
                            <!-- 工单审核按钮（费用costDetails有值时隐藏） -->
                            <div class="stage-action-buttons"
                                v-if="!readonly && (!selectedCostItem || !selectedCostItem.costDetails || selectedCostItem.costDetails.length === 0) && selectedOrderItem.status == 'TO_BE_THE_FINAL' && selectedOrderItem.isShow == '2' && permission.JOINS_SALES_CLOUD_WF_ORDER_PASSORREFUSE">
                                <el-button type="primary" size="small" :loading="actionLoading"
                                    @click.stop="passStageV2(selectedOrderItem.id)">通过</el-button>
                                <el-button type="danger" size="small" :loading="actionLoading"
                                    @click.stop="refuseStageV2(selectedOrderItem.id)">拒绝</el-button>
                            </div>
                            <!-- 工单反审核按钮 -->
                            <div class="stage-action-buttons"
                                v-if="!readonly && (selectedOrderItem.status == 'TO_BE_EVALUATED' || selectedOrderItem.status == 'COMPLETE')">
                                <el-button type="warning" size="small" icon="el-icon-refresh" :loading="actionLoading"
                                    v-if="permission.JOINS_SALES_CLOUD_WF_REVERSE_REVIEW"
                                    @click.stop="handleReverseReviewStageV2(selectedOrderItem.id)">反审核</el-button>
                            </div>
                        </el-card>
                        <!-- 工单无详情数据（有orderItem但list为空） -->
                        <el-card shadow="hover" class="card"
                            v-if="selectedOrderItem && (!selectedOrderItem.list || selectedOrderItem.list.length === 0)">
                            <div slot="header" class="card-header">
                                <span class="card-title"><i class="el-icon-document-checked"></i> {{
                                    selectedOrderItem.goodsName || '工单详情'
                                    }}</span>
                                <el-tag :type="getStatusType(selectedOrderItem.status)">
                                    {{ getStatusLabel(selectedOrderItem.status) }}
                                </el-tag>
                            </div>
                            <div class="custom-empty">
                                <i class="el-icon-document" style="font-size: 48px; color: #c0c4cc;"></i>
                                <p class="custom-empty-title">该工单暂无详情数据</p>
                                <p class="custom-empty-desc">温馨提示：该阶段工单尚未提交详情信息</p>
                            </div>
                        </el-card>
                        <!-- 无费用也无工单 -->
                        <div v-if="!selectedCostItem && !selectedOrderItem" class="custom-empty"
                            style="padding: 80px 20px;">
                            <i class="el-icon-warning-outline" style="font-size: 48px; color: #c0c4cc;"></i>
                            <p class="custom-empty-title">该阶段暂无费用和工单数据</p>
                            <p class="custom-empty-desc">温馨提示：数据可能尚未生成</p>
                        </div>
                        <!-- 历史退回原因 -->
                        <el-card shadow="hover" class="card" v-if="historyReasons">
                            <div slot="header" class="card-header">
                                <span class="card-title">历史退回原因</span>
                            </div>
                            <div class="form-row" v-for="(remark, index) in historyReasons.split(',')"
                                :key="'reason-' + index">
                                <p class="gap-line-border">
                                    <span><span class="nameStyle">第{{ index + 1 }}次退回原因:</span>{{ remark }}</span>
                                    <span class="gap-line"></span>
                                </p>
                            </div>
                        </el-card>
                    </div>
                    <!-- 空状态 -->
                    <div v-if="loadingCost" class="empty-content">
                        <i class="el-icon-loading" style="font-size: 32px; color: #409EFF;"></i>
                        <p style="color: #909399; margin-top: 12px;">数据加载中...</p>
                    </div>
                    <div v-else-if="!activeCategory || (activeCategory === 'stage' && !selectedMergedItem)"
                        class="empty-content">
                        <div class="custom-empty">
                            <i class="el-icon-folder-opened" style="font-size: 48px; color: #c0c4cc;"></i>
                            <p class="custom-empty-title" v-if="mergedStages.length === 0">
                                暂无阶段数据</p>
                            <p class="custom-empty-desc" v-if="mergedStages.length === 0">
                                温馨提示：当前报单暂无费用或工单数据</p>
                            <p class="custom-empty-title" v-else>请从左侧导航选择要查看的阶段</p>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="text" size="small" icon="el-icon-close" plain @click="closeDialog">关闭</el-button>
            </span>
        </el-dialog>
        <!-- 扣费项审减弹窗 -->
        <el-dialog :title="'扣费项审减'" :visible="showReduceDialog" @close="closeReduceDialog" :close-on-click-modal="false"
            append-to-body>
            <el-form :model="reduceForm" label-width="80px">
                <el-form-item label="费用项目">
                    <el-input v-model="reduceForm.itemName" placeholder="请输入费用项目"></el-input>
                </el-form-item>
                <el-form-item label="操作类型">
                    <el-select v-model="reduceForm.operationType" placeholder="请选择操作类型" style="width: 100%">
                        <el-option label="增加" value="1"></el-option>
                        <el-option label="扣减" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="金额">
                    <el-input v-model.number="reduceForm.amount" type="number" placeholder="请输入金额" min="0"
                        step="10"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeReduceDialog">取消</el-button>
                <el-button type="primary" @click="submitReduce" :loading="loadingReduce"
                    v-if="permission.JOINS_SALES_CLOUD_WF_COST_REDUCE">确认</el-button>
            </span>
        </el-dialog>
        <!-- 反审核确认弹窗（是否重新收方） -->
        <el-dialog title="反审核确认" :visible.sync="reverseReviewDialogVisible" width="420px"
            :close-on-click-modal="false" append-to-body @close="resetReverseReviewForm">
            <el-form :model="reverseReviewForm" label-width="100px">
                <el-form-item label="是否重新收方">
                    <el-switch v-model="reverseReviewForm.reCollect" active-color="#13ce66"
                        inactive-color="#dcdfe6"></el-switch>
                </el-form-item>
                <!-- el-form-item label="收方类型">
                    <span class="readonly-value">{{ collectTypeLabel }}</span>
                    <div class="form-tip">由当前阶段类型自动判定，无需手动选择</div>
                </el-form-item> -->
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="reverseReviewDialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="reverseReviewLoading" @click="confirmReverseReview">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { evaluateInfoView } from "@/api/salesCloud/preFilter";
import { findDataSourceFields } from "@/api/work/dynamicForm";
import { passOrRefusedV2, passOrRefusedAcceptanceV2, getWaterProofStage, getWaterProofOrderInfo, addOrReduceMoney, deleteOrReduceMoney, updateOrderCostVersion, calculateCostSingle, getAreaConfigByDeclarationId, queryMaterialShortage } from "@/api/work/waterProof/merchants";
import { reverseReviewWaterProof } from "@/api/work/waterProof/merchants";
import { getPunchRecords } from "@/api/work/attendance";
import { DIC } from "@/const/dic";
import { formatterTime } from "@/util/util";
export default {
    name: "ViewWaterProofStage",
    props: {
        visibleStage: {
            type: Boolean,
            required: true,
        },
        orderId: {
            type: [String, Number],
            required: true,
        },
        status: {
            type: String,
            required: true,
        },
        infoDetail: {
            type: Object,
            default: () => ({}),
        },
        totalPrice: {
            type: Number,
            default: 0,
        },
        id: {
            type: [String, Number],
            required: true,
        },
        // 跨模块互查场景下只读，隐藏所有审核/反审核/扣费等操作按钮，仅保留关闭
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            tableData: [], // 存放固定字段数据
            dynamicColumns: [], // 存放动态字段列数据
            imageFields: [], // 存放动态图片字段数据
            inputTypes: [], // 获取动态控件类型
            type: '',
            areaConfig: [], // 后端原始面积配置（部件维度数组）
            areaNewDisplayList: [], // 新版UI 反显用的区域数组（parts 结构），每个区域含 {name, parts, totalArea}
            areaOldDisplayList: [], // 旧版UI 反显用的区域数组（rigid/flexible 拆分结构）
            areaDisplayList: [], // 当前使用的反显数组（指向 new 或 old）
            isNewAreaFormat: false, // 是否为新格式面积数据（含刚性/柔性）
            isOldAreaData: false, // 是否为无 type/perimeter/height 字段的老数据
            forceOldAreaUI: false, // 是否强制使用老UI（回填阶段等），与移动端保持一致
            isNew: 0, // 顶层 UI 模式开关：默认 0=旧UI rigid/flexible 拆行；仅当后端明确返回 isNew=1 或基坑阶段才设为 1
            isJiKeng: false, // 是否为"基坑"阶段（柔性高度可自定义填写）
            isShow: true, // pc admin 后台为查看模式（与移动端 isShow 概念一致：true=查看）
            info: {},
            historyReasons: '',
            customsData: null,
            totalArea: '',
            costData: null, // 存放费用计算数据
            loadingCost: false, // 费用计算加载状态
            evaluateInfoList: [], // 存放工单详情列表数据
            // 侧边栏导航相关
            activeMenu: '', // 当前选中的菜单项
            activeCategory: '', // 当前选中的分类：cost / order / area
            activeIndex: 0, // 当前选中的索引
            // 扣费项审减相关
            showReduceDialog: false, // 扣费项审减弹窗可见性
            reduceForm: {
                itemName: '', // 费用项目
                operationType: '1', // 操作类型：增加/扣减
                amount: '', // 金额
                stageId: '', // 阶段ID
            },
            loadingReduce: false, // 扣费项审减加载状态
            loadingDelete: false, // 删除扣费项加载状态
            actionLoading: false, // 操作按钮加载状态（通过/拒绝/反审核）
            lastAreaConfigId: null, // 上次请求面积配置的ID
            materialShortageInfo: null, // 当前阶段材料兜底审核提示（单条）
            punchRecords: [], // 考勤打卡记录
            loadingPenalty: false, // 考勤数据加载状态
            // 反审核确认弹窗
            reverseReviewDialogVisible: false,
            reverseReviewForm: {
                reCollect: false,
                collectType: "",
            },
            reverseReviewLoading: false,
            reverseReviewStageId: null,
        };
    },
    computed: {
        ...mapGetters(["permission"]),
        // 反审核弹窗展示用：根据 collectType 返回可读文字
        collectTypeLabel() {
            return this.reverseReviewForm.collectType === "SUPPLEMENTARY" ? "涂料补刷收方 (SUPPLEMENTARY)" : "普通收方 (NORMAL)";
        },
        // 合并费用和工单（按id匹配，确保精度），按 sort 字段升序排序
        mergedStages() {
            const map = {};
            const result = [];
            // 先处理费用数据
            if (this.costData && this.costData.length > 0) {
                this.costData.forEach((item, index) => {
                    const key = String(item.id) || ('阶段' + (index + 1));
                    if (!map[key]) {
                        map[key] = { name: item.goodsName || ('阶段' + (index + 1)), costItem: null, orderItem: null };
                        result.push(map[key]);
                    }
                    map[key].costItem = item;
                });
            }
            // 再处理工单数据
            if (this.evaluateInfoList && this.evaluateInfoList.length > 0) {
                this.evaluateInfoList.forEach((item, index) => {
                    const key = String(item.id) || ('工单' + (index + 1));
                    if (!map[key]) {
                        map[key] = { name: item.goodsName || ('工单' + (index + 1)), costItem: null, orderItem: null };
                        result.push(map[key]);
                    }
                    map[key].orderItem = item;
                });
            }
            // 按 sort 字段升序排序：取 costItem 或 orderItem 中存在且为数字的 sort 值；都缺则置 Infinity 排到末尾
            const pickSort = (it) => {
                const raw = (it.costItem && it.costItem.sort != null) ? it.costItem.sort
                    : (it.orderItem && it.orderItem.sort != null) ? it.orderItem.sort : null;
                const n = Number(raw);
                return Number.isFinite(n) ? n : Infinity;
            };
            result.sort((a, b) => pickSort(a) - pickSort(b));
            return result;
        },
        // 当前选中的合并项
        selectedMergedItem() {
            if (this.activeCategory === 'stage' && this.mergedStages.length > this.activeIndex) {
                return this.mergedStages[this.activeIndex];
            }
            return null;
        },
        // 当前选中的费用项（从合并项中取）
        selectedCostItem() {
            if (this.selectedMergedItem) {
                return this.selectedMergedItem.costItem;
            }
            return null;
        },
        // 当前选中的工单项（从合并项中取）
        selectedOrderItem() {
            if (this.selectedMergedItem) {
                return this.selectedMergedItem.orderItem;
            }
            return null;
        },
        // 当前选中费用项对应的材料兜底信息（直接取单条记录）
        currentShortageInfo() {
            return this.materialShortageInfo;
        },
        // 面积配置展示总面积（基于 areaDisplayList 计算，兼容两种结构）
        areaConfigDisplayTotal() {
            if (this.areaDisplayList && this.areaDisplayList.length > 0) {
                const total = this.areaDisplayList.reduce((sum, area) => {
                    // 优先用 totalArea（新旧两套结构都已带），回退到 area 字段
                    const val = (area.totalArea !== undefined && area.totalArea !== '')
                        ? area.totalArea
                        : area.area;
                    return sum + this.safeNum(val);
                }, 0);
                return total ? total.toFixed(2) : '0.00';
            }
            // 兜底：若未反显，从原始 areaConfig 取
            if (this.areaConfig && this.areaConfig.length > 0) {
                const total = this.areaConfig.reduce((sum, item) => sum + this.safeNum(item.area), 0);
                return total ? total.toFixed(2) : '0.00';
            }
            return this.totalArea || '0.00';
        },
    },
    created() {
        // 初始加载时如果 orderId 已经有值，调用 handleList
        if (this.orderId) {
            this._syncStageFlags();
            // 获取动态控件类型
            findDataSourceFields().then(res => {
                let data = JSON.parse(res.data);
                this.inputTypes = data;
                // 获取产品数据
                const orderId = this.orderId; // 假设产品ID通过路由参数传递
                if (orderId) {
                    this.fetchGoodsData(orderId);
                    this.getCostData(orderId);
                    this.fetchEvaluateInfoList(orderId);
                    this.fetchAreaConfig(orderId);
                }
            })
        }
    },
    watch: {
        /**
         * 
         * @param newVal 
         * @description 监听 visibleStage 的变化
         * @returns void
         */
        visibleStage(newVal) {
            if (newVal && this.orderId) {
                // 重置导航状态
                this.activeMenu = '';
                this.activeCategory = '';
                this.activeIndex = 0;
                this._syncStageFlags();
                // 获取动态控件类型
                findDataSourceFields().then(res => {
                    let data = JSON.parse(res.data);
                    this.inputTypes = data;
                    // 获取产品数据
                    const orderId = this.orderId;
                    if (orderId) {
                        this.costData = null;
                        this.evaluateInfoList = [];
                        this.getCostData(orderId);
                        this.fetchEvaluateInfoList(orderId);
                        this.fetchAreaConfig(orderId);
                    }
                })
            }
        }
    },
    methods: {
        // 处理菜单选择
        handleMenuSelect(index) {
            this.activeMenu = index;
            if (index.startsWith('stage-')) {
                this.activeCategory = 'stage';
                this.activeIndex = parseInt(index.replace('stage-', ''));
                // 点击阶段时通过阶段ID获取面积配置
                const stageItem = this.mergedStages[this.activeIndex];
                const stageId = stageItem ? (stageItem.costItem ? stageItem.costItem.id : (stageItem.orderItem ? stageItem.orderItem.id : null)) : null;
                if (stageId) {
                    this.lastAreaConfigId = stageId;
                    this.fetchAreaConfig(stageId);
                    this.fetchMaterialShortage(stageId);
                    this.fetchPunchRecords(stageId);
                }
            }
        },
        // 自动选中第一个可用菜单项
        selectFirstAvailableMenu() {
            if (this.mergedStages && this.mergedStages.length > 0) {
                this.handleMenuSelect('stage-0');
            }
        },
        // 获取状态类型
        getStatusType(status) {
            switch (status) {
                case 'COMPLETE':
                case 'TO_BE_EVALUATED':
                    return 'success';
                case 'TO_BE_THE_FINAL':
                    return 'warning';
                case 'IN_SERVICE':
                    return 'primary';
                case 'WAIT_ACCEPT':
                case 'WAIT_FOR_ASSIGN':
                    return 'info';
                default:
                    return '';
            }
        },
        // 阶段通过审核
        passStageV2(stageId) {
            this.$confirm("确认通过该阶段？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.actionLoading = true;
                    let data = {
                        id: stageId,
                        status: 'TO_BE_EVALUATED',
                    }
                    passOrRefusedAcceptanceV2(data).then((res) => {
                        if (res.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "阶段审核通过成功",
                                type: "success",
                            });
                            this.$emit('refresh');
                            this.refreshAllData();
                        } else {
                            this.actionLoading = false;
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "error",
                            });
                        }
                    }).catch(() => { this.actionLoading = false; });
                })
                .catch(() => { });
        },
        // 阶段拒绝审核
        refuseStageV2(stageId) {
            this.$prompt("请输入拒绝原因", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputPattern: /^.{1,255}$/,
                inputErrorMessage: "请输入正确长度的拒绝原因1-255",
            })
                .then(({ value }) => {
                    this.actionLoading = true;
                    let data = {
                        id: stageId,
                        status: 'IN_SERVICE',
                        reason: value
                    }
                    passOrRefusedAcceptanceV2(data).then((response) => {
                        if (response.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "阶段审核拒绝成功",
                                type: "success",
                            });
                            this.$emit('refresh');
                            this.refreshAllData();
                        } else {
                            this.actionLoading = false;
                            this.$message({
                                showClose: true,
                                message: response.message,
                                type: "error",
                            });
                        }
                    }).catch(() => { this.actionLoading = false; });
                })
        },
        // 刷新所有阶段数据（费用+工单）
        refreshAllData() {
            this.actionLoading = true;
            Promise.all([
                this.getCostData(this.orderId),
                this.fetchEvaluateInfoList(this.orderId)
            ]).finally(() => {
                this.actionLoading = false;
            });
        },
        // 反审核（费用阶段）
        handleReverseReviewStage(stageId) {
            this.$confirm('是否确认反审核该阶段?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.actionLoading = true;
                reverseReviewWaterProof(stageId).then((res) => {
                    if (res.code == '200') {
                        this.$message.success('反审核成功');
                        this.$emit('refresh');
                        this.refreshAllData();
                    } else {
                        this.actionLoading = false;
                        this.$message.error(res.message || '反审核失败');
                    }
                }).catch(() => { this.actionLoading = false; });
            }).catch(() => { });
        },
        // 打开反审核确认弹窗（工单详情阶段）
        handleReverseReviewStageV2(stageId) {
            this.resetReverseReviewForm();
            this.reverseReviewStageId = stageId;
            // 由当前工单 name 自动判定收方类型：防水补刷→SUPPLEMENTARY，其余→NORMAL
            const name = (this.selectedOrderItem && (this.selectedOrderItem.name || this.selectedOrderItem.goodsName)) || "";
            this.reverseReviewForm.collectType = name === "防水补刷" ? "SUPPLEMENTARY" : "NORMAL";
            this.reverseReviewDialogVisible = true;
        },
        // 确认反审核
        confirmReverseReview() {
            const stageId = this.reverseReviewStageId;
            if (!stageId) return;
            const { reCollect, collectType } = this.reverseReviewForm;
            const payload = {
                reCollect,
                collectType: reCollect ? collectType : "",
                type: "WATERPROOF",
            };
            this.reverseReviewLoading = true;
            reverseReviewWaterProof(stageId, payload).then((res) => {
                if (res.code == '200') {
                    this.$message.success('反审核成功');
                    this.reverseReviewDialogVisible = false;
                    this.$emit('refresh');
                    this.refreshAllData();
                } else {
                    this.$message.error(res.message || '反审核失败');
                }
            }).catch(() => {
                // 接口异常不关闭弹窗，让用户重试
            }).finally(() => {
                this.reverseReviewLoading = false;
            });
        },
        // 关闭/重置反审核弹窗
        resetReverseReviewForm() {
            this.reverseReviewForm.reCollect = false;
            this.reverseReviewForm.collectType = "";
            this.reverseReviewStageId = null;
            this.reverseReviewLoading = false;
        },
        // 获取费用计算数据
        getCostData(orderId) {
            this.loadingCost = true;
            return getWaterProofStage(orderId).then(res => {
                if (res.code == "200") {
                    const parsedData = JSON.parse(res.data);
                    // 确保 costData 始终是数组格式
                    this.costData = Array.isArray(parsedData) ? parsedData : [parsedData];
                    // 数据加载完成后自动选中第一个
                    this.$nextTick(() => {
                        if (!this.activeMenu) {
                            this.selectFirstAvailableMenu();
                        }
                    });
                }
            }).finally(() => {
                this.loadingCost = false;
            });
        },
        // 获取考勤罚款预览
        fetchPunchRecords(stageId) {
            this.loadingPenalty = true;
            this.punchRecords = [];
            getPunchRecords(stageId).then(res => {
                if (res.code == '200' && res.data) {
                    try {
                        this.punchRecords = JSON.parse(res.data);
                    } catch (e) {
                        this.punchRecords = [];
                    }
                } else {
                    this.punchRecords = [];
                }
            }).catch(() => {
                this.punchRecords = [];
            }).finally(() => {
                this.loadingPenalty = false;
            });
        },
        // 根据 infoDetail.alias / selectedOrderItem.goodsName 同步 forceOldAreaUI、isJiKeng 标志
        _syncStageFlags() {
            const aliasOrName = ((this.infoDetail && this.infoDetail.alias) || '') + ' ' +
                (this.infoDetail && this.infoDetail.goodsName ? this.infoDetail.goodsName : '');
            const item = this.selectedOrderItem || {};
            const merged = `${aliasOrName} ${item.goodsName || ''} ${item.alias || ''}`;
            // 与移动端 childProject.js 保持一致：alias 含"回填"时强制老UI；alias 含"基坑"标记基坑
            this.forceOldAreaUI = merged.indexOf('回填') > -1;
            this.isJiKeng = merged.indexOf('基坑') > -1;
            // pc admin 后台为查看模式（与移动端 isShow=true 等价）
            this.isShow = true;
        },
        // 获取区域面积配置数据
        fetchAreaConfig(orderId) {
            // 切换阶段时同步标志（基于最新 selectedOrderItem）
            this._syncStageFlags();
            return getAreaConfigByDeclarationId(orderId, 1).then(res => {
                if (res.code == "200") {
                    const parsedData = JSON.parse(res.data);
                    const list = Array.isArray(parsedData) ? parsedData : (parsedData ? [parsedData] : []);
                    this.areaConfig = list;
                    // 是否新格式：任何记录有 type 字段
                    this.isNewAreaFormat = list.some(item => item.type !== undefined && item.type !== null && item.type !== '');
                    // 老数据判定：所有记录均无 type/perimeter/height/planeArea
                    this.isOldAreaData = !this.isNewAreaFormat;
                    // 顶层 isNew 模式开关：默认 0（Branch B 旧版UI）
                    // 仅当后端明确返回 isNew=1 时才走 Branch C（新数据格式）
                    this.isNew = 0;
                    if (this.isNewAreaFormat && list.length > 0) {
                        for (let i = 0; i < list.length; i++) {
                            const v = list[i] && list[i].isNew;
                            if (v !== undefined && v !== null && v !== '') {
                                this.isNew = (v == 1 || v === '1' || v === true) ? 1 : 0;
                                break;
                            }
                        }
                    }
                    // alias 含"回填"时强制老UI：覆盖 isNew 和 areaDisplayList
                    if (this.forceOldAreaUI) {
                        this.isNew = 0;
                    }
                    // 反显组装：分别构建新版/旧版两套结构
                    this.areaNewDisplayList = this._buildNewUIAreaList(list);
                    this.areaOldDisplayList = this._buildOldUIAreaList(list);
                    this.areaDisplayList = (this.isNew == 1) ? this.areaNewDisplayList : this.areaOldDisplayList;
                } else {
                    this.areaConfig = [];
                    this.isNewAreaFormat = false;
                    this.isOldAreaData = false;
                    this.isNew = 0;
                    this.areaNewDisplayList = [];
                    this.areaOldDisplayList = [];
                    this.areaDisplayList = [];
                }
            }).catch((err) => {
                this.areaConfig = [];
                this.isNewAreaFormat = false;
                this.isOldAreaData = false;
                this.isNew = 0;
                this.areaNewDisplayList = [];
                this.areaOldDisplayList = [];
                this.areaDisplayList = [];
            });
        },
        // 新版UI 反显组装：{name, totalArea, parts:[{type, perimeter, height, area, expression}]}
        _buildNewUIAreaList(areaConfig) {
            if (!areaConfig || areaConfig.length === 0) return [];
            const list = areaConfig;
            // 老数据：无 type/perimeter/height/planeArea 字段 → 简单 name+area
            if (list.every(c => !c.type && !c.perimeter && !c.height && !c.planeArea)) {
                return list.map((config, idx) => ({
                    key: `old-${idx}`,
                    name: config.name || '',
                    totalArea: config.area || '0.00',
                    planeExpressions: config.planeExpressions || '',
                    parts: [
                        { type: 'rigid', perimeter: '', height: '', area: config.area || '0', sort: 1 },
                    ],
                }));
            }
            const areaMap = {};
            let sortIndex = 1;
            const planeProcessed = {};
            list.forEach((config) => {
                const rawName = config.name || '';
                const areaType = String(rawName).replace(/\d+$/, "");
                const areaNumber = parseInt(String(rawName).replace(/\D/g, "")) || 1;
                const areaName = `${areaType}${areaNumber}` || rawName;
                if (!areaMap[areaName]) {
                    areaMap[areaName] = {
                        key: `area-${sortIndex}`,
                        name: areaName,
                        sort: sortIndex++,
                        totalArea: '',
                        parts: [],
                        planeExpressions: '',
                    };
                }
                // 收集 areaName 下的计算式（多 config 时按表达式去重，最后逗号拼接）
                const exprRaw = String(config.planeExpressions || '');
                if (exprRaw) {
                    if (!areaMap[areaName]._planeExprSet) {
                        areaMap[areaName]._planeExprSet = new Set();
                    }
                    exprRaw.split(',').map(s => s.trim()).filter(Boolean)
                        .forEach(s => areaMap[areaName]._planeExprSet.add(s));
                }
                const typeStr = String(config.type);
                let partType = 'rigid';
                if (typeStr === '2') partType = 'flexible';
                if (typeStr === '3') partType = 'plane';
                const part = { type: partType, sort: areaMap[areaName].parts.length + 1 };
                if (partType === 'plane') {
                    part.expression = config.planeArea || '';
                    part.area = config.area || '';
                } else {
                    part.perimeter = config.perimeter || '';
                    part.height = config.height || '';
                    part.area = config.area || '';
                    const isNewFlag = config.isNew == null ? 1 : (config.isNew == 0 ? 0 : 1);
                    const configSort = config.sort == null ? '' : String(config.sort);
                    const planeExpressionsRaw = String(config.planeExpressions || '');
                    const groupKey = `${areaName}__sort_${configSort}__isNew_${isNewFlag}__exprs_${planeExpressionsRaw}`;
                    if (!planeProcessed[groupKey]) {
                        const planeExprs = planeExpressionsRaw
                            .split(',')
                            .map(s => s.trim())
                            .filter(Boolean);
                        planeExprs.forEach((expr) => {
                            areaMap[areaName].parts.push({
                                type: 'plane',
                                expression: expr,
                                area: this._evalExpression(expr),
                                sort: areaMap[areaName].parts.length + 1,
                            });
                        });
                        planeProcessed[groupKey] = true;
                    }
                }
                areaMap[areaName].parts.push(part);
            });
            const areaList = Object.values(areaMap);
            areaList.forEach((item) => {
                const hasRigid = item.parts.some(p => p.type === 'rigid');
                if (!hasRigid) {
                    item.parts.unshift({ type: 'rigid', perimeter: '', height: '', area: '', sort: 0 });
                }
                item.parts.forEach((p, idx) => { p.sort = idx + 1; });
                item.totalArea = this._calcAreaTotal(item.parts);
                // 把去重后的计算式集转为逗号分隔字符串
                if (item._planeExprSet && item._planeExprSet.size > 0) {
                    item.planeExpressions = Array.from(item._planeExprSet).join(',');
                    delete item._planeExprSet;
                } else {
                    delete item._planeExprSet;
                }
            });
            return areaList;
        },
        // 旧版UI 反显组装：{name, area, totalArea, rigid{perimeter,height,planeArea,area}, flexible{...}, canDeleteFlexible, flexibleDeleted}
        _buildOldUIAreaList(areaConfig) {
            if (!areaConfig || areaConfig.length === 0) return [];
            const list = areaConfig;
            // 老数据：无 type/perimeter/height/planeArea → 简单 name+area
            if (list.every(c => !c.type && !c.perimeter && !c.height && !c.planeArea)) {
                return list.map((config, idx) => ({
                    key: `old-${idx}`,
                    name: config.name || '',
                    area: config.area || '0.00',
                    totalArea: config.area || '0.00',
                    planeExpressions: config.planeExpressions || '',
                    rigid: { area: config.area || '0', perimeter: '', height: '', planeArea: '' },
                    flexible: { area: '', perimeter: '', height: '', planeArea: '' },
                    flexibleDeleted: true, // 老数据默认不含柔性行
                    canDeleteFlexible: false,
                }));
            }
            const areaMap = {};
            let sortIndex = 1;
            list.forEach((config) => {
                const rawName = config.name || '';
                const areaType = String(rawName).replace(/\d+$/, "");
                const areaNumber = parseInt(String(rawName).replace(/\D/g, "")) || 1;
                const areaName = `${areaType}${areaNumber}` || rawName;
                if (!areaMap[areaName]) {
                    areaMap[areaName] = {
                        key: `area-${sortIndex}`,
                        name: areaName,
                        sort: sortIndex++,
                        area: '',
                        totalArea: '',
                        rigid: { area: '', perimeter: '', height: '', planeArea: '' },
                        flexible: { area: '', perimeter: '', height: '', planeArea: '' },
                        flexibleDeleted: false,
                        canDeleteFlexible: false,
                        planeExpressions: '',
                    };
                }
                // 收集 areaName 下的计算式（多 config 时按表达式去重，最后逗号拼接）
                const exprRaw = String(config.planeExpressions || '');
                if (exprRaw) {
                    if (!areaMap[areaName]._planeExprSet) {
                        areaMap[areaName]._planeExprSet = new Set();
                    }
                    exprRaw.split(',').map(s => s.trim()).filter(Boolean)
                        .forEach(s => areaMap[areaName]._planeExprSet.add(s));
                }
                const typeStr = String(config.type);
                const bucket = typeStr === '2' ? areaMap[areaName].flexible : areaMap[areaName].rigid;
                bucket.perimeter = config.perimeter || '';
                bucket.height = config.height || '';
                bucket.planeArea = config.planeArea || '';
                bucket.area = config.area || '';
            });
            const areaList = Object.values(areaMap);
            areaList.forEach((item) => {
                // 仅取刚性面积（与移动端 submit-work-order.js 行为一致：柔性不计入）
                const rigidArea = parseFloat(item.rigid.area) || 0;
                item.area = rigidArea.toFixed(2);
                item.totalArea = item.area;
                // 柔性高度默认 0.27（非基坑阶段）；与移动端默认值保持一致
                if (!item.flexible.height && !this.isJiKeng) {
                    item.flexible.height = '0.27';
                }
                // 把去重后的计算式集转为逗号分隔字符串
                if (item._planeExprSet && item._planeExprSet.size > 0) {
                    item.planeExpressions = Array.from(item._planeExprSet).join(',');
                }
                delete item._planeExprSet;
            });
            return areaList;
        },
        // 轻量表达式求值（仅支持 + - * 与数字、小数点、空格）
        _evalExpression(expr) {
            if (expr == null) return '';
            const s = String(expr).trim();
            if (!s) return '';
            if (!/^[\d+\-*\s\.]+$/.test(s)) return '';
            let i = 0;
            const peek = () => s[i];
            const skipSpace = () => { while (i < s.length && s[i] === ' ') i++; };
            const parseNumber = () => {
                skipSpace();
                const start = i;
                if (peek() === '+' || peek() === '-') i++;
                while (i < s.length && /[\d\.]/.test(s[i])) i++;
                const n = parseFloat(s.slice(start, i));
                if (!isFinite(n)) throw new Error('bad number');
                return n;
            };
            const parseTerm = () => {
                let left = parseNumber();
                while (true) {
                    skipSpace();
                    if (peek() !== '*') break;
                    i++;
                    left = left * parseNumber();
                }
                return left;
            };
            const parseExpr = () => {
                let left = parseTerm();
                while (true) {
                    skipSpace();
                    const op = peek();
                    if (op !== '+' && op !== '-') break;
                    i++;
                    const right = parseTerm();
                    left = op === '+' ? left + right : left - right;
                }
                return left;
            };
            try {
                skipSpace();
                const result = parseExpr();
                skipSpace();
                if (i !== s.length) return '';
                if (!isFinite(result)) return '';
                return result.toFixed(2);
            } catch (e) {
                return '';
            }
        },
        // 单区域总面积（刚性 + 平面，柔性不计入）
        _calcAreaTotal(parts) {
            if (!parts) return '0.00';
            let total = 0;
            parts.forEach((p) => {
                if (p.type === 'rigid' || p.type === 'plane') {
                    total += parseFloat(p.area) || 0;
                }
            });
            return total.toFixed(2);
        },
        // 判断 parts 中是否含墙面类型
        hasWallParts(parts) {
            if (!parts) return false;
            return parts.some(p => p.type === 'rigid' || p.type === 'flexible');
        },
        // 判断 parts 中是否含平面类型
        hasPlaneParts(parts) {
            if (!parts) return false;
            return parts.some(p => p.type === 'plane');
        },
        // 提取墙面部件
        wallParts(parts) {
            if (!parts) return [];
            return parts.filter(p => p.type === 'rigid' || p.type === 'flexible')
                .sort((a, b) => a.sort - b.sort);
        },
        // 提取平面部件
        planeParts(parts) {
            if (!parts) return [];
            return parts.filter(p => p.type === 'plane')
                .sort((a, b) => a.sort - b.sort);
        },
        // 旧版UI：将 area.rigid/flexible 转换为表格行（柔性被删时不含柔性行）
        buildOldAreaRows(area) {
            const rows = [];
            if (area && area.rigid) {
                rows.push({
                    kind: 'rigid',
                    perimeter: area.rigid.perimeter || '',
                    height: area.rigid.height || '',
                    planeArea: area.rigid.planeArea || '',
                    area: area.rigid.area || '0',
                });
            }
            if (area && area.flexible && !area.flexibleDeleted) {
                rows.push({
                    kind: 'flexible',
                    perimeter: area.flexible.perimeter || '',
                    height: area.flexible.height || '',
                    planeArea: area.flexible.planeArea || '',
                    area: area.flexible.area || '0',
                });
            }
            return rows;
        },
        // 获取材料兜底审核提示信息（按阶段ID查询单条）
        fetchMaterialShortage(stageId) {
            return queryMaterialShortage(stageId).then(res => {
                if (res.code == "200") {
                    const data = JSON.parse(res.data);
                    // 接口返回数组时取第一条（传子工单ID只返回单条）
                    this.materialShortageInfo = Array.isArray(data) ? (data[0] || null) : (data || null);
                } else {
                    this.materialShortageInfo = null;
                }
            }).catch(() => {
                this.materialShortageInfo = null;
            });
        },
        // 格式化时间（毫秒时间戳）
        formatTimestamp(time) {
            if (!time) return '';
            return formatterTime(time);
        },
        // 安全转换为数字
        safeNum(val) {
            const n = parseFloat(val);
            return isNaN(n) ? 0 : n;
        },
        // 规范化费用版本，null/空/V2 为 V2，V1 为 V1
        normalizeCostVersion(v) {
            if (!v) return 'V2';
            const s = String(v).trim().toUpperCase();
            return s === 'V1' ? 'V1' : 'V2';
        },
        // 获取计费版本的中文展示名称
        getCostVersionLabel(v) {
            return this.normalizeCostVersion(v) === 'V1' ? '老工艺' : '新工艺';
        },
        // 待评价及之后的状态不可切换计费版本
        canSwitchCostVersion(status) {
            return !['TO_BE_EVALUATED', 'COMPLETE'].includes(status);
        },
        // 切换子工单计费版本标签
        handleSwitchCostVersion(orderId, version, currentVersion) {
            if (!orderId) return;
            const target = String(version || '').toUpperCase() === 'V1' ? 'V1' : 'V2';
            if (currentVersion && target === currentVersion) return; // 无变化不作为
            const versionLabel = this.getCostVersionLabel(target);
            this.$confirm(
                `确认将该工单计费版本切换为<span style="color:#f56c6c;font-weight:bold;">【${versionLabel}】</span>？原费用记录会被删除并重新计算。`,
                '切换计费版本',
                {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).then(() => {
                const loading = this.$loading({
                    lock: true,
                    text: `正在切换为 ${versionLabel} 并重算费用...`,
                    spinner: 'el-icon-loading',
                    background: 'rgba(255,255,255,0.6)'
                });
                updateOrderCostVersion(orderId, target).then(res => {
                    if (res && (res.code == '200' || res.code === undefined)) {
                        return this.refreshSingleCost(orderId).then(() => {
                            this.$message.success(`已切换为 ${versionLabel}，费用已重新计算`);
                        });
                    }
                    this.$message.error((res && res.message) || '切换计费版本失败');
                }).catch(err => {
                    this.$message.error((err && err.message) || '切换计费版本异常');
                }).finally(() => {
                    loading.close();
                });
            }).catch(() => {
                // 取消后：因为单选按钮是单向绑定 (:value)，视图依然反映原始值，无需手动回滚
            });
        },
        // 刷新单子工单费用，并覆盖 costData 中对应项
        refreshSingleCost(orderId) {
            return calculateCostSingle(orderId).then(res => {
                if (res && res.code == '200' && res.data) {
                    let parsed;
                    try {
                        parsed = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
                    } catch (e) {
                        parsed = res.data;
                    }
                    const newItem = Array.isArray(parsed) ? parsed[0] : parsed;
                    if (newItem && this.costData && this.costData.length) {
                        const idx = this.costData.findIndex(it => String(it.id) === String(orderId));
                        if (idx >= 0) {
                            this.$set(this.costData, idx, newItem);
                        }
                    }
                }
            });
        },
        // 阶段通过审核
        passStage(stageId) {
            const versionLabel = this.selectedCostItem ? this.getCostVersionLabel(this.selectedCostItem.costVersion) : '';
            this.$confirm(`当前计费版本为<span style="color:#f56c6c;font-weight:bold;">【${versionLabel}】</span>，确认通过该阶段？`, "提示", {
                dangerouslyUseHTMLString: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.actionLoading = true;
                    let data = {
                        id: stageId,
                        status: 'TO_BE_EVALUATED',
                    }
                    passOrRefusedV2(data).then((res) => {
                        if (res.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "阶段审核通过成功",
                                type: "success",
                            });
                            this.$emit('refresh');
                            // 刷新当前阶段数据
                            this.refreshAllData();
                        } else {
                            this.actionLoading = false;
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "error",
                            });
                        }
                    }).catch(() => { this.actionLoading = false; });
                })
                .catch(() => { });
        },
        // 阶段拒绝审核
        refuseStage(stageId) {
            const versionLabel = this.selectedCostItem ? this.getCostVersionLabel(this.selectedCostItem.costVersion) : '';
            this.$prompt(`当前计费版本为<span style="color:#f56c6c;font-weight:bold;">【${versionLabel}】</span>，请输入拒绝原因`, "提示", {
                dangerouslyUseHTMLString: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputPattern: /^.{1,255}$/,
                inputErrorMessage: "请输入正确长度的拒绝原因1-255",
            })
                .then(({ value }) => {
                    this.actionLoading = true;
                    let data = {
                        id: stageId,
                        status: 'IN_SERVICE',
                        reason: value
                    }
                    passOrRefusedV2(data).then((response) => {
                        if (response.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "阶段审核拒绝成功",
                                type: "success",
                            });
                            this.$emit('refresh');
                            // 刷新当前阶段数据
                            this.refreshAllData();
                        } else {
                            this.actionLoading = false;
                            this.$message({
                                showClose: true,
                                message: response.message,
                                type: "error",
                            });
                        }
                    }).catch(() => { this.actionLoading = false; });
                })
        },
        pass() {
            this.$confirm("确认通过？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let data = {
                        declarationId: this.id,
                        status: 'TO_BE_EVALUATED',
                    }
                    passOrRefusedV2(data).then((res) => {
                        if (res.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "操作成功",
                                type: "success",
                            });
                            this.$emit('refresh');
                            this.closeDialog();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.message,
                                type: "error",
                            });
                        }
                    });
                })
                .catch(() => { });
        },
        refuse() {
            this.$prompt("请输入拒绝原因", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                inputPattern: /^.{1,255}$/,
                inputErrorMessage: "请输入正确长度的拒绝原因1-255",
            })
                .then(({ value }) => {
                    let data = {
                        declarationId: this.id,
                    }
                    data.status = 'IN_SERVICE';
                    data.reason = this.historyReasons ? this.historyReasons + ',' + value : value;
                    passOrRefusedV2(data).then((response) => {
                        if (response.code == "200") {
                            this.$message({
                                showClose: true,
                                message: "操作成功",
                                type: "success",
                            });
                            this.$emit('refresh');
                            this.closeDialog();
                        } else {
                            this.$message({
                                showClose: true,
                                message: response.message,
                                type: "error",
                            });
                        }
                    });
                })
        },
        /**
         * 
         * @param orderId 工单ID
         * @description 获取工单数据
         * @returns void
         */
        fetchGoodsData(orderId) {
            const params = {
                id: orderId,
                code: this.evaluateInfo ? 'AFTER_SALES_EVALUATION' : 'WORK_HANG_CEILING'
            };
            evaluateInfoView(params).then(res => {
                if (res.code == "200") {
                    const jsonData = JSON.parse(res.data); // 解析返回的 JSON 数据
                    // 将图片字段单独处理（8-图片上传、12-仅拍照）
                    const imageFields = jsonData.list.filter(item => item.inputType == '8' || item.inputType == '12').map(item => ({
                        id: item.id,
                        fieldName: item.fieldName,
                        inputType: this.getInputType(item.inputType), // 获取输入类型
                        fieldValue: item.value
                    }));
                    this.imageFields = imageFields;
                    // 其他字段
                    const dynamicColumns = jsonData.list.filter(item => item.inputType != '8' && item.inputType != '12').map(item => ({
                        id: item.id,
                        fieldName: item.fieldName,
                        inputType: this.getInputType(item.inputType), // 获取输入类型
                        fieldValue: item.dataType.word == 'star' ? parseInt(item.value) : item.value
                    }));
                    const area = dynamicColumns.find(item => item.fieldName === '施工面积');
                    this.totalArea = area ? area.fieldValue : '';
                    this.dynamicColumns = dynamicColumns;
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error"
                    });
                }
            })
        },
        /**
         * 
         * @param orderId 工单ID
         * @description 获取工单详情列表数据
         * @returns void
         */
        fetchEvaluateInfoList(orderId) {
            return getWaterProofOrderInfo(orderId).then(res => {
                if (res.code == "200") {
                    const parsedData = JSON.parse(res.data);
                    // 当parsedData为空时，关闭当前组件并通知父组件打开viewOrder组件
                    if (!parsedData || (Array.isArray(parsedData) && parsedData.length === 0)) {
                        // 先触发打开viewOrder事件，确保父组件接收到
                        this.$emit('openViewOrder');
                        // 然后关闭当前弹窗
                        this.$emit("update:visibleStage", false);
                        return;
                    }
                    // 确保evaluateInfoList始终是数组格式
                    this.evaluateInfoList = Array.isArray(parsedData) ? parsedData : [parsedData];
                    // 每个阶段的图片信息已经在模板中直接处理，不需要单独提取到全局数组
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error"
                    });
                }
            }).catch(err => {
                this.$message({
                    showClose: true,
                    message: '获取工单详情失败',
                    type: "error"
                });
            })
        },
        /**
         * 
         * @param length 
         * @description 动态计算每列的span值
         * @returns number
         */
        getSpan(length) {
            // 动态计算每列的span值
            return Math.floor(24 / Math.min(length, 3)); // 最多3列
        },
        /**
         * 
         * @param row 
         * @description 格式化图片字段
         * @returns Array
         */
        formmaterImage(row) {
            let str = new Array();
            if (row != null) {
                let picArray = row.split(",");
                for (let i = 0; i < picArray.length; i++) {
                    str.push(picArray[i]);
                }
            }
            return str;
        },
        /**
         * 
         * @param inputType 
         * @description 获取输入类型的名称
         * @returns string
         */
        getInputType(inputType) {
            const item = this.inputTypes.find(type => type.id == inputType);
            return item ? item.word : ''; // 返回输入类型的名称
        },
        /**
         * 
         * @param status 
         * @description 获取状态的名称
         * @returns string
         */
        getStatusLabel(status) {
            const statusItem = DIC.PRE_FILTER_STATUS.find(item => item.value === status);
            return statusItem ? statusItem.label : status;
        },
        /**
         * 
         * @description 关闭弹窗
         * @returns void
         */
        closeDialog() {
            // 清空弹窗数据
            this.tableData = [];
            this.dynamicColumns = [];
            this.imageFields = [];
            this.info = {};
            this.historyReasons = '';
            this.customsData = null;
            this.evaluateInfoList = [];
            this.areaConfig = [];
            this.areaDisplayList = [];
            this.areaNewDisplayList = [];
            this.areaOldDisplayList = [];
            this.isNewAreaFormat = false;
            this.isOldAreaData = false;
            this.isNew = 0;
            this.forceOldAreaUI = false;
            this.isJiKeng = false;
            this.isShow = true;
            this.activeMenu = '';
            this.activeCategory = '';
            this.activeIndex = 0;
            this.actionLoading = false;
            this.lastAreaConfigId = null;
            this.materialShortageInfo = null;
            this.reduceForm = {
                itemName: '', // 费用项目
                operationType: '1',
                amount: '',
                stageId: ''
            };
            this.showReduceDialog = false;
            this.closeReduceDialog();
            this.$emit("update:visibleStage", false);
        },
        /**
         * 
         * @param list 工单详情列表
         * @description 处理工单详情数据
         * @returns Array
         */
        processEvaluateItemList(list) {
            if (!list || list.length === 0) return [];
            // 过滤掉图片类型的字段（8-图片上传、12-仅拍照，图片现在显示在各自阶段中）
            return list.filter(item => item.inputType != '8' && item.inputType != '12').map(item => ({
                id: item.id,
                fieldName: item.fieldName,
                inputType: item.dataType ? item.dataType.word : this.getInputType(item.inputType),
                fieldValue: item.dataType && item.dataType.word == 'star' ? parseInt(item.value) : item.value
            }));
        },
        /**
         * 
         * @param list 工单详情列表
         * @description 获取当前阶段的图片字段
         * @returns Array
         */
        getStageImageFields(list) {
            if (!list || list.length === 0) return [];
            // 提取图片类型的字段
            return list.filter(item => item.inputType == '8' || item.inputType == '12').map(item => ({
                id: item.id,
                fieldName: item.fieldName,
                inputType: this.getInputType(item.inputType),
                fieldValue: item.value
            }));
        },
        // 打开扣费项审减弹窗
        openReduceDialog(stageId) {
            this.reduceForm = {
                itemName: '', // 费用项目
                operationType: '1',
                amount: '',
                stageId: stageId
            };
            this.showReduceDialog = true;
        },
        // 关闭扣费项审减弹窗
        closeReduceDialog() {
            this.showReduceDialog = false;
            this.reduceForm = {
                itemName: '', // 费用项目
                operationType: '1',
                amount: '',
                stageId: ''
            };
        },
        // 提交扣费项审减
        submitReduce() {
            if (!this.reduceForm.amount || this.reduceForm.amount <= 0) {
                this.$message({
                    showClose: true,
                    message: '请输入有效的金额',
                    type: 'error'
                });
                return;
            }
            this.loadingReduce = true;
            const data = {
                remarks: this.reduceForm.itemName, // 费用项目
                orderId: this.reduceForm.stageId,
                type: this.reduceForm.operationType,
                amount: this.reduceForm.amount
            };
            addOrReduceMoney(data).then(res => {
                if (res.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "扣费项审减操作成功",
                        type: "success"
                    });
                    this.showReduceDialog = false;
                    this.closeReduceDialog();
                    // 刷新费用数据
                    this.getCostData(this.orderId);
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error"
                    });
                }
            }).finally(() => {
                this.loadingReduce = false;
            });
        },
        // 删除扣费项
        deleteReduceItem(id) {
            this.$confirm("确认删除该扣费项？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                this.loadingDelete = true;
                deleteOrReduceMoney(id).then(res => {
                    if (res.code == "200") {
                        this.$message({
                            showClose: true,
                            message: "删除成功",
                            type: "success"
                        });
                        this.closeReduceDialog();
                        // 刷新费用数据
                        this.getCostData(this.orderId);
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: "error"
                        });
                    }
                }).finally(() => {
                    this.loadingDelete = false;
                });
            }).catch(() => { });
        },
    },
};
</script>
<style scoped>
/* 全屏弹窗样式 */
.fixed-header-footer-dialog {
    z-index: 20;
    display: flex;
    flex-direction: column;
}
.fixed-header-footer-dialog::v-deep .el-dialog__header {
    position: fixed !important;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #fff;
    padding: 10px 20px;
    border-bottom: 1px solid #ebeef5;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.fixed-header-footer-dialog::v-deep .el-dialog__body {
    position: absolute;
    top: 55px;
    bottom: 55px;
    left: 0;
    right: 0;
    padding: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}
.fixed-header-footer-dialog::v-deep .el-dialog__footer {
    position: fixed !important;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #fff;
    padding: 10px 20px;
    border-top: 1px solid #ebeef5;
    box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
    text-align: right;
}
/* 报单基本信息 */
.declaration-info {
    flex-shrink: 0;
    background-color: #f5f7fa;
    border-bottom: 1px solid #ebeef5;
    padding: 10px 20px;
}
.declaration-info-row {
    display: flex;
    flex-wrap: wrap;
    gap: 4px 0;
}
.declaration-info-item {
    flex: 0 0 20%;
    min-width: 180px;
    display: flex;
    align-items: center;
    padding: 2px 8px;
    font-size: 13px;
    line-height: 1.6;
}
.info-label {
    color: #909399;
    white-space: nowrap;
    margin-right: 4px;
}
.info-value {
    color: #303133;
    word-break: break-all;
}
/* 左右布局 */
.stage-layout {
    display: flex;
    flex: 1;
    overflow: hidden;
}
/* 左侧侧边栏 */
.stage-sidebar {
    width: 260px;
    min-width: 260px;
    border-right: 1px solid #ebeef5;
    overflow-y: auto;
    background-color: #fafbfc;
    display: flex;
    flex-direction: column;
}
.sidebar-title {
    padding: 14px 16px 10px;
    font-size: 13px;
    font-weight: 600;
    color: #909399;
    letter-spacing: 1px;
    text-transform: uppercase;
    flex-shrink: 0;
}
.sidebar-card-list {
    flex: 1;
    padding: 0 10px 10px;
    display: flex;
    flex-direction: column;
    gap: 6px;
}
.sidebar-card {
    display: flex;
    align-items: center;
    padding: 10px 12px;
    border-radius: 8px;
    background: #fff;
    border: 1px solid #ebeef5;
    cursor: pointer;
    transition: all 0.2s ease;
    gap: 10px;
}
.sidebar-card:hover {
    border-color: #c6e2ff;
    background: #ecf5ff;
    box-shadow: 0 2px 6px rgba(64, 158, 255, 0.08);
}
.sidebar-card--active {
    border-color: #409EFF;
    background: #ecf5ff;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.15);
}
.sidebar-card--active .sidebar-card__icon {
    background: #409EFF;
    color: #fff;
}
.sidebar-card--active .sidebar-card__name {
    color: #409EFF;
    font-weight: 600;
}
.sidebar-card--active .sidebar-card__arrow {
    color: #409EFF;
}
.sidebar-card__icon {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    background: #f0f2f5;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 16px;
    color: #606266;
    transition: all 0.2s ease;
}
.sidebar-card__icon--area {
    background: #f0f9eb;
    color: #67c23a;
}
.sidebar-card--active .sidebar-card__icon--area {
    background: #67c23a;
    color: #fff;
}
.sidebar-card__body {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.sidebar-card__name {
    font-size: 13px;
    color: #303133;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: all 0.2s ease;
}
.sidebar-card__tags {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-wrap: wrap;
}
.sidebar-card__arrow {
    flex-shrink: 0;
    font-size: 12px;
    color: #c0c4cc;
    transition: all 0.2s ease;
}
/* 右侧内容区 */
.stage-content {
    flex: 1;
    overflow: hidden;
    background-color: #f5f7fa;
}
.content-scroll {
    height: 100%;
    overflow-y: auto;
    box-sizing: border-box;
}
.empty-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
}
/* 侧边栏空状态 */
.sidebar-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 30px 10px;
    color: #909399;
    font-size: 13px;
}
.sidebar-empty p {
    margin-top: 8px;
}
/* 自定义空状态 */
.custom-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
}
.custom-empty-title {
    margin-top: 16px;
    font-size: 14px;
    color: #606266;
}
.custom-empty-desc {
    margin-top: 8px;
    font-size: 13px;
    color: #909399;
}
/* 卡片样式 */
.card {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    background-color: #fff;
}
.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
}
.card-title-wrap {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
    flex: 1;
    min-width: 0;
}
.version-switcher {
    display: inline-flex;
    align-items: center;
    padding: 3px 10px 3px 12px;
    background: linear-gradient(135deg, #ecf5ff 0%, #f0f9ff 100%);
    border: 1px solid #b3d8ff;
    border-radius: 20px;
    box-shadow: 0 2px 6px rgba(64, 158, 255, 0.12);
}
.cost-version-bar+.card {
    margin-top: 12px;
}
.cost-version-bar:empty {
    display: none;
}
.version-switcher__label {
    font-size: 13px;
    font-weight: 600;
    color: #409eff;
    margin-right: 8px;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
}
.version-switcher__label i {
    margin-right: 4px;
    font-size: 14px;
}
.version-radio {
    display: inline-flex;
    align-items: center;
}
.version-radio ::v-deep .el-radio {
    margin-right: 12px;
    line-height: 1;
}
.version-radio ::v-deep .el-radio:last-child {
    margin-right: 0;
}
.version-radio ::v-deep .el-radio__label {
    font-size: 13px;
    font-weight: 500;
    color: #606266;
}
.card-title {
    font-weight: bold;
    font-size: 16px;
}
.card-content {
    word-break: break-word;
}
/* 阶段时间信息（报单时间/进场打卡时间/提交工单时间/审单时间） */
.stage-time-info {
    padding: 8px 12px;
    margin-bottom: 12px;
    background-color: #f5f7fa;
    border-radius: 4px;
    border-left: 3px solid #409EFF;
}
.stage-time-info .el-col {
    display: flex;
    align-items: center;
    font-size: 13px;
    line-height: 1.6;
    padding: 2px 0;
}
/* 区块标题 */
.section-title {
    font-weight: bold;
    font-size: 14px;
    margin: 20px 0 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #ebeef5;
    color: #303133;
}
.section-title i {
    margin-right: 4px;
}
/* 费用汇总 */
.cost-summary {
    margin-top: 12px;
    padding: 10px 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
}
.cost-summary p {
    margin: 4px 0;
    font-size: 14px;
}
.text-primary {
    color: #1890ff;
    font-weight: bold;
}
/* 工程师信息区块 */
.info-section {
    margin-top: 16px;
    padding: 12px 15px;
    background-color: #f9f9f9;
    border-radius: 4px;
    border-left: 3px solid #409EFF;
}
.info-section p {
    margin: 6px 0;
    font-size: 14px;
    line-height: 1.6;
}
/* 材料兜底审核提示（红色警告） */
.material-shortage-warning {
    margin-top: 14px;
    padding: 10px 14px;
    background-color: #fff2f0;
    border: 1px solid #ffccc7;
    border-left: 4px solid #FF4D4F;
    border-radius: 4px;
    color: #FF4D4F;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.6;
    display: flex;
    align-items: flex-start;
    gap: 8px;
}
.material-shortage-warning i {
    font-size: 16px;
    margin-top: 2px;
    flex-shrink: 0;
}
/* 操作按钮 */
.stage-action-buttons {
    margin-top: 20px;
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
    border-top: 1px solid #ebeef5;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}
/* 图片 */
.card-image {
    width: 100px;
    height: 100px;
    margin: 5px;
    border-radius: 5px;
    border: 1px solid #ccc;
    cursor: pointer;
    transition: transform 0.3s ease;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.gap-line-border {
    padding: 0 10px;
    border: 1px dashed #ccc;
}
.gap-line {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background-color: #ccc;
    margin-top: 10px;
}
.nameStyle {
    font-weight: bold;
    line-height: 4px;
}
.form-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 10px;
}
.form-row p {
    flex: 1;
    min-width: calc(20% - 10px);
    box-sizing: border-box;
    margin: 0;
}
/* 侧边栏滚动条 */
.stage-sidebar::-webkit-scrollbar {
    width: 6px;
}
.stage-sidebar::-webkit-scrollbar-track {
    background: transparent;
}
.stage-sidebar::-webkit-scrollbar-thumb {
    background: #dcdfe6;
    border-radius: 3px;
}
.stage-sidebar::-webkit-scrollbar-thumb:hover {
    background: #c0c4cc;
}
/* 内容区滚动条 */
.content-scroll::-webkit-scrollbar {
    width: 8px;
}
.content-scroll::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}
.content-scroll::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
}
.content-scroll::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}
/* 响应式 */
@media (max-width: 768px) {
    .stage-layout {
        flex-direction: column;
    }
    .stage-sidebar {
        width: 100%;
        min-width: 100%;
        max-height: 200px;
        border-right: none;
        border-bottom: 1px solid #ebeef5;
    }
    .card-image {
        width: 80px;
        height: 80px;
    }
}
/* 面积详情 */
.area-block {
    margin-bottom: 16px;
    border: 1px solid #ebeef5;
    border-radius: 6px;
    overflow: hidden;
}
.area-block:last-child {
    margin-bottom: 0;
}
.area-block-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 14px;
    background: #f5f7fa;
    border-bottom: 1px solid #ebeef5;
}
.area-block-name {
    font-weight: 600;
    font-size: 14px;
    color: #303133;
}
.area-block-total {
    font-size: 13px;
    color: #1989fa;
    font-weight: 600;
}
/* 部件分组 */
.parts-group {
    padding: 0 14px 12px;
}
.parts-group-title-row {
    display: flex;
    align-items: baseline;
    gap: 8px;
    padding: 10px 0 8px;
    border-bottom: 1px dashed #ebeef5;
}
.parts-group-title {
    font-weight: 600;
    font-size: 13px;
    color: #303133;
}
.group-wall .parts-group-title {
    color: #1989fa;
}
.group-plane .parts-group-title {
    color: #67c23a;
}
.parts-group-tip {
    font-size: 12px;
    color: #909399;
}
/* 部件类型标签 */
.area-inline-tag {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.4;
    white-space: nowrap;
}
.tag-rigid {
    background: #ecf5ff;
    color: #1989fa;
    border: 1px solid #b3d8ff;
}
.tag-flexible {
    background: #fff7e6;
    color: #fa6400;
    border: 1px solid #ffd591;
}
.tag-plane {
    background: #f0f9eb;
    color: #67c23a;
    border: 1px solid #c2e7b0;
}
/* 计算式展示 */
.plane-expression-text {
    color: #303133;
    font-family: 'Consolas', 'Monaco', monospace;
    font-size: 13px;
}
.plane-expression-placeholder {
    color: #c0c4cc;
    font-size: 13px;
}
/* 计入/不计入标签 */
.area-tag-tip {
    margin-left: 8px;
    font-size: 11px;
    padding: 1px 6px;
    border-radius: 8px;
    background: #f0f9eb;
    color: #67c23a;
}
.area-tag-tip--gray {
    background: #f4f4f5;
    color: #909399;
}
/* 新版UI 列标题（对齐移动端 parts-cols-header） */
.parts-cols-header {
    display: flex;
    align-items: center;
    padding: 8px 10px;
    margin: 8px 0 6px;
    background: #f5f7fa;
    border-radius: 4px;
    font-size: 12px;
    color: #606266;
    font-weight: 600;
}
.parts-col-tag {
    flex: 0 0 100px;
    text-align: center;
}
.parts-col-input {
    flex: 1;
    text-align: center;
}
.parts-col-expression {
    flex: 1;
    text-align: center;
}
.parts-col-x {
    flex: 0 0 24px;
    text-align: center;
    color: #909399;
    font-weight: 400;
}
.parts-col-result {
    flex: 0 0 130px;
    text-align: center;
}
/* 旧版UI 顶部提示行（rigid.area + 平面面积，对齐移动端 area-item-area-stack） */
.old-summary-row {
    display: flex;
    align-items: center;
    padding: 10px 14px 0;
    gap: 12px;
    flex-wrap: wrap;
}
.old-summary-text {
    color: #1989fa;
    font-weight: 600;
    font-size: 13px;
}
.old-summary-plane {
    color: #909399;
    font-size: 12px;
}
/* Branch A 老UI：单行展示（名称 + 计算式 + 面积徽章） */
.old-area-line {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
    background: #fff;
}
.old-area-name {
    flex: 0 0 auto;
    font-weight: 600;
    font-size: 14px;
    color: #303133;
    padding-right: 12px;
    border-right: 1px solid #ebeef5;
}
.old-area-expr-wrap {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    overflow: hidden;
}
.old-area-tag {
    flex: 0 0 auto;
    padding: 1px 8px;
    border-radius: 10px;
    background: #f4f4f5;
    color: #909399;
    font-size: 12px;
    line-height: 1.6;
    white-space: nowrap;
}
.old-area-expr {
    flex: 1;
    min-width: 0;
    color: #606266;
    font-size: 13px;
    font-family: 'Consolas', 'Monaco', monospace;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.old-area-badge {
    flex: 0 0 auto;
    padding: 3px 12px;
    border-radius: 12px;
    background: #ecf5ff;
    color: #1989fa;
    border: 1px solid #b3d8ff;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
}
/* 考勤信息卡片样式 */
.attendance-info {
    padding: 10px;
}
.punch-photo {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border-radius: 4px;
    cursor: pointer;
    border: 1px solid #eee;
    display: inline-block;
    margin: 2px 4px 2px 0;
    vertical-align: top;
}
.form-tip {
    color: #909399;
    font-size: 12px;
    line-height: 1.5;
    margin-top: 4px;
}
.readonly-value {
    display: inline-block;
    padding: 0 12px;
    height: 32px;
    line-height: 32px;
    background: #f5f7fa;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    color: #606266;
    font-size: 14px;
}
</style>